export const STORAGE_KEY_SELF_HOSTED_IS_ADMIN_USER_LOGGED_IN = "SELF_HOSTED_installation_token";
